import { getCmsRole } from "./permissions";

/**
 * Wat het CMS doet met de auth- en profielstatus van de ingelogde gebruiker
 * (gebruikt door RequireCmsRole in views/index.js).
 *
 * - `loading`   — Firebase of het profiel is nog niet binnen: laadscherm.
 * - `ok`        — profiel met CMS-rol. Ook als de profiel-listener intussen een
 *                 fout gaf: dan werken we door met het laatst bekende profiel
 *                 en probeert useAuth het opnieuw.
 * - `error`     — het profiel kon niet worden gelezen en er is er ook nog geen.
 *                 GEEN reden om uit te loggen: tot 13-10-2026 betekende elke
 *                 fout op die listener een stille uitlog (zie docs/cms-toegang.md).
 * - `no_access` — het profiel is gelezen en heeft geen CMS-rol, of er bestaat
 *                 geen profieldocument. Dan wél uitloggen.
 */
export const SESSION_LOADING = "loading";
export const SESSION_OK = "ok";
export const SESSION_ERROR = "error";
export const SESSION_NO_ACCESS = "no_access";

export const getCmsSessionState = ({ loading, profileLoading, profile, profileError }) => {
  if (loading || profileLoading) return SESSION_LOADING;
  if (profile) return getCmsRole(profile) ? SESSION_OK : SESSION_NO_ACCESS;
  if (profileError) return SESSION_ERROR;
  return SESSION_NO_ACCESS;
};

/** Reden van een uitlog door het CMS zelf, voor de Guardian-melding. */
export const getNoAccessReason = (profile) => (profile ? "no_cms_role" : "no_profile_document");

const RETRY_DELAYS_MS = [2000, 5000, 15000];
const MAX_RETRY_DELAY_MS = 30000;

/**
 * Wachttijd vóór de n-de nieuwe poging (1 = eerste) om de profiel-listener
 * opnieuw te starten nadat hij een fout gaf: 2s, 5s, 15s, daarna elke 30s.
 */
export const profileRetryDelayMs = (attempt) =>
  attempt >= 1 && attempt <= RETRY_DELAYS_MS.length ? RETRY_DELAYS_MS[attempt - 1] : MAX_RETRY_DELAY_MS;
